export default class Sticky {
  originalPadding
  breakpoint
  compensation

  constructor(element, behaviorName = 'mhg_sticky', offsetTop = null){
    this.element = element.eq(0)
    this.offsetTop = offsetTop
    this.behaviorName = behaviorName

    this.apply()
  }

  apply(){
    if (this.element.length) {
      this.element.once(this.behaviorName, () => {
        // Save original padding on top. 0 timeout to get correct padding.
        /*setTimeout(function() {
          this.originalPadding = jQuery('body').css('paddingTop');
        }, 0);*/
        this.breakpoint = this.offsetTop || this.element.offset().top;
        //we need to compensate the element so that the content does not jump up.
        this.compensation = this.offsetTop || this.element.outerHeight()
        jQuery(window).scroll(() => {
          if (jQuery(window).scrollTop() > this.breakpoint) {
            this.element.addClass('mhg-sticky-active');
            // jQuery('body').css('padding-top', this.compensation);
          }
          else {
            this.element.removeClass('mhg-sticky-active');
            // jQuery('body').css('padding-top', this.originalPadding);
          }
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/sticky.js